import React from 'react';
import { CircularProgress } from '../circular-progress/circular-progress';
import { calculatePercentage } from '../../lib/utils/math';

import styles from './stage-header.module.scss';
type StageHeaderProps = {
  index: number;
  name: string;
  completed: number;
  total: number;
  isActive?: boolean;
};

export const StageHeader: React.FC<StageHeaderProps> = ({
  index,
  name,
  completed,
  total,
  isActive,
}) => {
  const progress = calculatePercentage(completed, total);

  return (
    <div className={styles['container']} data-active={isActive}>
      <div className={styles['header']}>
        <div className={styles['title']} isActive={isActive}>
          <div className={styles['stage-number']} isActive={isActive}>
            {index.toString().padStart(2, '0')}
          </div>
          <h3>{name}</h3>
        </div>

        <div className={styles['header-progress']}>
          <CircularProgress progress={progress} />
          <div className={styles['progress-indicator']}>
            <span>{completed}</span>/{total}
          </div>
        </div>
      </div>
    </div>
  );
};

type IsActiveProps = {
  isActive?: boolean;
};
